module.exports = function(video) {
	'use strict'
	video.directive('uppyDashboard',uppyDashboard);
	uppyDashboard.$inject=['$timeout','$interval','alertService'];
	function uppyDashboard($timeout,$interval, alertService) {
		return {
			restrict: 'E',
            scope: {
                parentObj:'=',
                uploadUrl: '=',
                getVideoUrl: '=',
                authorization:'='
            },
            template: require('./partial/uppyDashboard.html'),
            replace:true,
            link: function(scope, element) {
                scope.transcoding = false;
                scope.transcodingComplete = false;
                scope.transcodingProgress = 0;
                var firstUpload;
                var getVideoInterval;
                var uppy = new Uppy.Core({
                    autoProceed: true,
                    allowMultipleUploadBatches:false,
                    restrictions: {
                        maxNumberOfFiles: 1,
                        maxFileSize: 100 * 1024 * 1024 * 1024, // 100GB limit
                        allowedFileTypes: ['video/*'] // Specify allowed file types
                    }
                })
                .use(Uppy.Dashboard, {
                    target: '#uppyDashboard',
                    inline: true,
                    replaceTargetContent: true,
                    showProgressDetails: true,
                    proudlyDisplayPoweredByUppy: false,
                    doneButtonHandler :null,
                    height: 320,
                    metaFields: [
                        { id: 'name', name: 'Name', placeholder: 'file name' }
                    ]
                })
                .use(Uppy.Tus, {
                    endpoint: scope.uploadUrl, // Backend endpoint
                    resume: true,
                    chunkSize: 4 * 1024 * 1024, // 4MB chunk size
                    retryDelays: [0, 1000, 3000, 5000], // Retry delays in milliseconds
                    onBeforeRequest: function(req,file) {
                        // if(scope.parentObj.breaking) {
                        //     // req.url = scope.uploadUrl + '?is_urgent=1';
                        //     req.open(req.method, scope.uploadUrl + '?is_urgent=1');
                        // }
                        req.setHeader('Authorization', scope.authorization)
                        // req.setHeader('is_urgent',scope.parentObj.breaking)
                    },
                    onAfterResponse:function(response) {
                        var uploadUrl = (scope.parentObj.breaking)? scope.uploadUrl + '?is_urgent=1': scope.uploadUrl;
                        if(response && response._method == "POST" && response._url == uploadUrl && response._xhr && response._xhr.response) {
                            var responseObj = JSON.parse(response._xhr.response)
                            if(responseObj.video) {
                                scope.videoObjId = responseObj.video.id;
                            }
                            if(!firstUpload) {
                                scope.parentObj.onUpload()
                                firstUpload = true
                            }
                        }

                    }
                });
                scope.$watch(function(){
                    return scope.parentObj.breaking
                  }, function(newValue, oldValue){
                    if (newValue!=oldValue) {
                        uppy.getPlugin('Tus').opts.endpoint = (newValue)? scope.uploadUrl + '?is_urgent=1': scope.uploadUrl;
                    }
                  },true);
                // uppy.on('upload-started', function(file, upload) {
                    
                // });
                // uppy.on('file-added', (file) => {
                //     console.log('Added file', file);
                // });
                // uppy.on('upload', function(data) {
                //     console.log(data)
                // });
                // uppy.on('progress', function(progress) {
                //     // progress: integer (total progress percentage)
                //     // console.log(progress);
                // });
                // Handle successful uploads
                // Handle errors
                // uppy.on('upload-error', function(file,error, response) {
                //     // console.log('Upload error:', error);
                //     console.log(error.message)
                // });
                uppy.on('complete', function(result) {
                    // console.log('Upload complete:', result.successful);
                    // console.log('failed files:', result.failed);
                    if(result.failed && result.failed.length>0 && result.failed[0] && result.failed[0].error) {
                        var responseText = result.failed[0].error.match(/\{([^}]*)\}/)
                        var response;
                        if(responseText && responseText.length>0) {
                            responseText = result.failed[0].error.match(/\{([^}]*)\}/)[0]
                            try {
                                response = JSON.parse(responseText)
                            } catch(error) {

                            } 
                            if(response && response.message) {
                                scope.$apply(function () {
                                    alertService('danger','Opps! ', response.message);
                                })
                            }
                        }
                    } 
                });
                // Add your logic to handle successful uploads
                uppy.on('upload-success', function(file, response){
                    if(scope.videoObjId) {
                        getVideo(scope.videoObjId)
                    } else {
                        alertService('danger','Opps! ', 'Something went wrong. VideoId is not exist.');
                    }
                })
                function getVideo(videoId){
                    var options = {
                        headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': scope.authorization
                        }
                    };
                    getVideoInterval = $interval(function(){
                        fetchVideo()
                    },2000)
                    fetchVideo()
                    function fetchVideo() {
                        fetch(scope.getVideoUrl + videoId, options)
                        .then(function(response) {
                            return response.json()
                        })
                        .then(function(data){ 
                            console.log(data.data)
                            scope.$apply(function () {
                                scope.transcoding = true;
                            })
                            if(data && data.data) {
                                scope.$apply(function () {
                                    scope.transcodingProgress = data.data.transcoding_progress;
                                })
                            }
                            if(data.data.transcoding_progress == 100) {
                                scope.$apply(function () {
                                    scope.transcodingComplete = true;
                                    scope.parentObj.transcodingDone(data.data)
                                    $interval.cancel(getVideoInterval);
                                    getVideoInterval = null
                                })
                            }
                        })
                        .catch(function(error) { 
                            console.error(error)
                        });
                    }
                }
                scope.$on('$destroy', function() {
                    // Remove event listeners
                    uppy.close(); // or uppy.off() to remove specific event listeners
                    // Destroy the Uppy instance
                    uppy = null;
                    $interval.cancel(getVideoInterval);
                    getVideoInterval = null
                });
            }
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/new-video/js/directive/uppyDashboardDirective.js
// module id = 644
// module chunks = 0